<template>
    <el-row class="warp">
        <!--编辑对话框界面 begin-->
        <el-dialog 
            title="编辑出版类型" 
            :visible.sync="editFormVisible" 
            :close-on-click-modal="false"
        >
            <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm">
                <!-- 创建form -->
                <el-form-item label="出版类型名称：" prop="pubName">
                    <el-input v-model="editForm.pubName" placeholder="在此输入配置名称"></el-input>
                </el-form-item>
            </el-form>
            <!-- 创建form -->
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </el-row>
</template>

<script>
import API_PUB from "../../../api/api_pub";

export default {
    name: "editPubDialog",
    components: {},
    props: {
        pub: {
            type:Object,
            required: true
        },
    },
    data() {
        return{
            
            //新增相关数据UserName
            editFormVisible: false, //新增界面是否显示
            editLoading: false, //新增界面加载状态
            editFormRules: {
                pubName: [
                    { required: true, message: "请输入出版类型名称", trigger: "blur" }
                ]
            },
            editForm: {
                pubId:"",
                pubName: "",
            },
        };
    },

    methods:{
        closeDialog() {
            this.editFormVisible = false;
            this.$emit('signStatusVerdict',true);
        },
        openDialog(){
            this.editForm.pubId= this.pub.pubId;
            this.editForm.pubName = this.pub.pubName;
            this.editFormVisible = true;       
        },
        //新增提交
        editSubmit: function() {
            let that = this;
            if (that.formLoading) return;

            that.$refs.editForm.validate(valid => {
            if (valid) {
                let params = {
                    pubId: that.editForm.pubId,
                    pubName: that.editForm.pubName,
                };

                console.log(
                    ".........pub edit by params:" + JSON.stringify(params)
                );

                //发送http请求
                API_PUB.updatePub(params)
                    .then(res => {
                    if (0 === res.errorCode) {
                        that.$message({
                        type: "success",
                        message: "创建成功!"
                        });

                        that.$refs["editForm"].resetFields(); //清空数据
                        that.editFormVisible = false;
                        that.$emit('signStatusVerdict',true);
                    } else {
                        that.$message({
                        showClose: true,
                        message: res.errorInfo,
                        type: "error"
                        });
                    }
                    })
                    .catch(e => {
                    that.$message({
                        showClose: true,
                        type: "error",
                        message: "请求出现异常",
                        duration: 2000
                    });
                    });
                } 
            else {
                that.$message({
                    showClose: true,
                    type: "error",
                    message: "请正确填写信息！",
                    duration: 2000
                });
            }
            });
        },
    },
};

</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/SysMng/PubType/EditPub.vue